import ContextConstructor from "../Context/Context";
import sendLogError from "../../sendLogError";

import Popup from "reactjs-popup";
import { withRouter } from "react-router-dom";
import { NavLink } from "react-router-dom";
import React, { Component } from "react";

import GestorPopup from "../Sidebar/GestorPopup";
import TermsAndConditionsPopup from "../Sidebar/TermsAndConditionsPopup";
import Quotas from "../../pages/Quotas/Quotas";

//imagens
import add_person from "../../images/add_person.png";


import "./Navbar.css";

class DesktopNavbar extends Component {
    constructor(props) {
        super(props);
        this.routeChange = this.routeChange.bind(this);
        this.state = {
            openLeft: false,
            openRight: false,
            drawerStyle: `
        {
            "background": "#F9F9F9",
            "boxShadow": "rgba(0, 0, 0, 0.188235) 0px 10px 20px, rgba(0, 0, 0, 0.227451) 0px 6px 6px"
        }`,
            relativeWidth: false,
            widthLogoutMenu: 380,
            widthSideMenu: 380,
            noTouchOpen: false,
            noTouchClose: false,
            name: "",
            profile: [],
            terms: [],
            hasNotification: false,
            loading: true,
            showVotarSide: true,
            actualDate: null,
            startDate: null,
            endDate: null,
            actualDateAVOA: null,
            endDateAVOA: null,
            startDateAVOA: null,
            associates: [],
            selectedUserClientID: "",
            isActualUser: "",
            showTermsPopup: false,
            termsData: null,
            isCheckingTerms: true,
            otherPopupsPending: [],
            defaultContact: null
        };
    }



    routeChange() {
        let path = "/profile";
        this.props.history.push(path);
    }

    async componentDidMount() {

        await this.checkTermsAndConditions();

        if (!this.state.showTermsPopup) {
            this.initializeOtherComponents();
        }
    }

    async checkTermsAndConditions() {
        try {
            const { idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`
            };

            const response = await fetch("/Profile/GetTermsStatus", {
                method: "GET",
                headers
            });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const termsStatus = await response.json();

            if (termsStatus.requiresAcceptance) {
                this.setState({
                    showTermsPopup: true,
                    termsData: termsStatus,
                    isCheckingTerms: false
                });
            } else {
                this.setState({
                    isCheckingTerms: false
                });
            }

        } catch (error) {
            console.error("Error checking terms:", error);

            this.setState({
                isCheckingTerms: false
            });

            sendLogError(error.message, "checkTermsAndConditions");
        }
    }

    handleCloseTerms = () => {
        this.setState({
            showTermsPopup: false,
            termsData: null
        }, () => {
            this.initializeOtherComponents();
        });
    }

    handleAcceptTerms = async (optInsAccepted) => {
        try {
            const { idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
                'Content-Type': 'application/json'
            };

            const payload = {
                termsId: this.state.termsData.termsId,
                version: this.state.termsData.currentVersion,
                optInsAccepted: optInsAccepted
            };

            const response = await fetch("/Profile/AcceptTerms", {
                method: "POST",
                headers,
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            this.setState({
                showTermsPopup: false,
                termsData: null
            }, () => {
                this.initializeOtherComponents();
            });

        } catch (error) {
            console.error("Error accepting terms:", error);

            sendLogError(error.message, "handleAcceptTerms");
        }
    };

    initializeOtherComponents() {

        this.getAVOApopup();
        this.getTermsLink();
        this.populateProfileData();
        this.populateProfileData();

        setTimeout(() => {
            this.getManagerInfo();
            this.getContactUsInfo();
        }, 2000);

        if (
            this.context.selectedUserID !== "" &&
            this.context.selectedUserID !== undefined &&
            this.context.selectedUserID !== null &&
            this.manager &&
            this.manager.employeeNumber === "" &&
            this.manager.employeeNumber === null
        ) {
            this.getNotificationStatus();
        }
    }

    async getAVOApopup() {
        try {
            const { showTermsPopup, otherPopupsPending } = this.state;

            if (showTermsPopup) {
                this.setState({
                    otherPopupsPending: [...otherPopupsPending, "AVOA"]
                });
                return;
            }

            const { idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
            };

            const response = await fetch("/Elections/GetAVOADates", { headers });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const data = await response.json();

            // validação defensiva
            if (!data?.actualDateAVOA || !data?.startDateAVOA || !data?.endDateAVOA) {
                throw new Error("Dados inválidos (AVOA)");
            }

            this.setState({
                actualDateAVOA: data.actualDateAVOA,
                startDateAVOA: data.startDateAVOA,
                endDateAVOA: data.endDateAVOA,
            });

            const showedAVOAPopup = window.sessionStorage.getItem("showedAVOAPopup");

            const AVOAstart = new Date(data.startDateAVOA);
            const AVOAend = new Date(data.endDateAVOA);
            const AVOAactual = new Date(data.actualDateAVOA);

            if (AVOAactual > AVOAstart && AVOAactual < AVOAend) {
                if (showedAVOAPopup !== "true" && !showTermsPopup) {
                    document.getElementById("popupSubscricaoReforco")?.click();
                }
            }

        } catch (error) {
            console.error("Error fetching AVOA popup:", error);

            sendLogError(error.message, "getAVOApopup");
        }
    }

    setWidth = (e) => {
        this.setState({
            width: Number(e.target.value) || e.target.value,
        });
    };

    setTouch = (e) => {
        this.setState({
            [e.target.name]: !e.target.checked,
        });
    };

    setDrawerStyle = (e) => {
        e.preventDefault();
        this.setState({
            drawerStyle: this.drawerStyleRef.value,
        });
    };

    getInitials = (name) => {
        if (!name || typeof name !== "string") {
            return "D U";
        }

        var names = name.split(" ");
        let x = names[0][0] + " " + names[names.length - 1][0];
        return x;
    };

    getNameCapitalize = (name) => {
        if (typeof name !== "string" || !name.trim()) {
            return "";
        }

        return name
            .toLowerCase()
            .split(" ")
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(" ");
    };

    utf8Decode(utf8String) {
        if (typeof utf8String != "string")
            throw new TypeError("parameter 'utf8String' is not a string");
        const unicodeString = utf8String
            .replace(
                /[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g,
                function (c) {
                    var cc =
                        ((c.charCodeAt(0) & 0x0f) << 12) |
                        ((c.charCodeAt(1) & 0x3f) << 6) |
                        (c.charCodeAt(2) & 0x3f);
                    return String.fromCharCode(cc);
                },
            )
            .replace(
                /[\u00c0-\u00df][\u0080-\u00bf]/g,
                function (c) {
                    var cc = ((c.charCodeAt(0) & 0x1f) << 6) | (c.charCodeAt(1) & 0x3f);
                    return String.fromCharCode(cc);
                },
            );
        return unicodeString;
    }

    closeMenuFunction = () => {
        this.setState({
            openLeft: false,
            openRight: false,
        });
    };

    switchToAssociateUser = (associate) => {
        this.setState({
            openLeft: false,
            openRight: false,
            name: this.getNameCapitalize(associate.name),
        });

        this.context.changeselectedUserID(associate);
        this.getManagerInfo();
        this.getContactUsInfo();
    };

    buttonAddMenor() {
        if (this.context.tokenUser === this.context.selectedUserID) {
            return (
                <NavLink to="/AdicionaMenor" style={{ textDecoration: "none" }}>
                    <div onClick={this.closeMenuFunction} className="adicionaassociadomenor">
                        <img src={add_person} alt="" width="26px" height="´26px" />
                        <div style={{ marginTop: "15px", marginLeft: "7px" }}>
                            Adicionar Criança ou Jovem Associado
                        </div>
                    </div>
                </NavLink>
            );
        } else {
            return "";
        }
    }

    getSafeDisplayName = (name) => {
        if (typeof name !== "string") return "";
        return this.getNameCapitalize(name);
    };


    render() {
        const {
            openRight,
        } = this.state;

        if (openRight !== this.props.openProfile && this.props.openProfile) {
            this.setState({ openRight: this.props.openProfile, openLeft: false });
        }


        let termsAndConditionsPopup = null;
        if (this.state.showTermsPopup && this.state.termsData) {
            termsAndConditionsPopup = (
                <TermsAndConditionsPopup
                    termsData={this.state.termsData}
                    close={this.handleCloseTerms}
                    onAccept={this.handleAcceptTerms}
                    onClose={this.handleCloseTerms}
                />
            );
        }

        let popupGestor = (
            <Popup
                trigger={<div id="popupGestorTrigger" style={{ display: "none" }}></div>}
                modal
                closeOnDocumentClick={!this.state.showTermsPopup}
                contentStyle={{ background: "none", border: "none" }}>
                {(close) => (
                    <div><GestorPopup
                        manager={this.state.manager}
                        defaultContact={this.state.defaultContact}
                        close={close}
                        hasManager={this.state.hasManager}
                    /></div>
                )}
            </Popup>
        );


        return (
            <div>
                {this.state.profile.stateCode === "C" ? (
                    <>
                        {popupGestor}
                        < Quotas />
                    </>
                ) :
                    <>
                        {termsAndConditionsPopup}
                        {!this.state.showTermsPopup && (
                            <>
                                {popupGestor}
                            </>
                        )}
                    </>
                }
            </div >
        );
    }

    async populateProfileData() {
        const selectedUser = this.context.selectedUser;
        if (!selectedUser || !selectedUser.name) {
            return;
        }

        const profileName = selectedUser.name;
        const profileNameUTF8 = this.getNameCapitalize(
            this.utf8Decode(profileName)
        );

        this.setState({ name: profileNameUTF8, loading: false });
    }

    async getTermsLink() {
        try {
            const { idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
            };

            const response = await fetch("/Auth/GetTermsLink", { headers });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const data = await response.json();
            const termsLink = data?.value;

            this.setState({ terms: termsLink });

        } catch (error) {
            console.error("Error fetching terms link:", error);

            sendLogError(error.message, "getTermsLink");
        }
    }

    async getNotificationStatus() {
        try {
            const { selectedUserID, idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
                clientId: selectedUserID,
            };

            const response = await fetch(
                `/Notifications/GetNotifications?ClientId=${selectedUserID}`,
                { headers }
            );

            if (!response.ok) {
                this.setState({ hasNotification: false });
                return;
            }

            const data = await response.json();

            // verifica se existe alguma não lida
            const hasUnread = Array.isArray(data)
                ? data.some((item) => !item.isRead)
                : false;

            this.setState({
                hasNotification: hasUnread,
            });

        } catch (error) {
            console.error("Error fetching notifications:", error);

            this.setState({
                hasNotification: false
            });

            sendLogError(error.message, "getNotificationStatus");
        }
    }

    async getManagerInfo() {
        try {
            const { selectedUserID, idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
            };

            const response = await fetch(
                `/Profile/GetManager?ClientId=${selectedUserID}`,
                { headers }
            );

            if (!response.ok) {
                this.setState({
                    hasManager: false,
                    manager: null,
                    loading: false
                });

                return;
            }

            const data = await response.json();
            const hasValidManager =
                data && (data.name || data.email || data.employeeNumber)

            this.setState({
                hasManager: !!hasValidManager,
                manager: hasValidManager ? data : null,
                loading: false
            });
        } catch (error) {
            console.error("Error fetching manager info:", error);

            this.setState({
                hasManager: false,
                loading: false
            });

            sendLogError(error.message, "getManagerInfo");
        }
    }

    async getContactUsInfo() {
        try {
            const { idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
            };

            const response = await fetch(
                `/Profile/GetContactUs`,
                { headers }
            );

            if (!response.ok) {
                this.setState({
                    hasManager: false,
                    manager: null,
                    defaultContact: null,
                    loading: false
                });

                return;
            }

            const data = await response.json();
            this.setState({
                defaultContact: data,
                loading: false
            });
            console.log(JSON.stringify(data));

        } catch (error) {
            console.error("Error fetching manager info:", error);

            this.setState({
                hasManager: false,
                loading: false
            });

            sendLogError(error.message, "getManagerInfo");
        }
    }

    async populateAssociateData() {
        try {
            const { idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
            };

            // Buscar associados
            const resAssociates = await fetch("/Profile/GetMymAssociates", { headers });

            if (!resAssociates.ok) {
                throw new Error(`Erro ao obter associados: ${resAssociates.status}`);
            }

            const data = await resAssociates.json();

            let parsed = [];

            try {
                parsed = data?.value ? JSON.parse(data.value) : [];
            } catch (e) {
                console.error("Erro a fazer parse de associados", e);
                parsed = [];
            }

            const associates = Array.isArray(parsed) ? parsed : [];

            // Buscar perfil do utilizador
            const resProfile = await fetch("/Profile/GetProfile", { headers });

            if (!resProfile.ok) {
                throw new Error(`Erro ao obter perfil: ${resProfile.status}`);
            }

            const userProfileResponse = await resProfile.json();

            const isValidProfile = userProfileResponse
                && Object.keys(userProfileResponse).length > 0
                && userProfileResponse.clientID;

            // Adicionar utilizador atual
            associates.push(userProfileResponse);

            let selectedUserClientID = "";

            if (isValidProfile) {
                // Marcar token user
                associates.forEach((associated) => {
                    if (associated.clientID === userProfileResponse.clientID) {
                        associated.isTokenUser = true;
                        selectedUserClientID = associated.clientID;
                    } else {
                        associated.isTokenUser = false;
                    }
                });
            }

            // Atualizar estado
            this.setState({
                associates,
                loading: false,
                selectedUserClientID,
                isActualUser: userProfileResponse.clientID,
            });

            // Guardar em localStorage
            const montepioUser = {
                menores: associates,
                selectedUserClientID,
                isActualUser: userProfileResponse.clientID,
            };

            localStorage.setItem("montepioUser", JSON.stringify(montepioUser));

        } catch (error) {
            console.error("Error in populateAssociateData:", error);

            this.setState({ loading: false });

            sendLogError(error.message, "populateAssociateData");
        }
    }
}

DesktopNavbar.contextType = ContextConstructor;

export default withRouter(DesktopNavbar);